module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), " ", _vm._h('div', {
    staticClass: "panel-body"
  }, [_vm._h('form', {
    attrs: {
      "data-toggle": "validator"
    }
  }, [_vm._h('div', {
    staticClass: "row"
  }, [_vm._m(1), " ", _vm._h('div', {
    staticClass: "col-md-6"
  }, [_vm._h('div', {
    staticClass: "form-group"
  }, [_vm._h('div', {
    staticClass: "input-group"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.inAgeY),
      expression: "inAgeY",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "150",
      "placeholder": "Years",
      "required": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.inAgeY)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inAgeY = _vm._n($event.target.value)
      }
    }
  }), " ", _vm._m(2), " ", _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.inAgeM),
      expression: "inAgeM",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "11",
      "placeholder": "Months",
      "autocomplete": "off",
      "data-error": "Months must be between 0 to 11"
    },
    domProps: {
      "value": _vm._s(_vm.inAgeM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inAgeM = _vm._n($event.target.value)
      }
    }
  }), " ", _vm._m(3), " ", _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.inAgeD),
      expression: "inAgeD",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "30",
      "placeholder": "Days",
      "autocomplete": "off",
      "data-error": "Days must be between 0 to 30"
    },
    domProps: {
      "value": _vm._s(_vm.inAgeD)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inAgeD = _vm._n($event.target.value)
      }
    }
  }), " ", _vm._m(4)]), " ", _vm._m(5)])])]), " ", _vm._h('div', {
    staticClass: "row"
  }, [_vm._m(6), " ", _vm._h('div', {
    staticClass: "col-md-5"
  }, [_vm._h('div', {
    staticClass: "form-group"
  }, [_vm._h('div', {
    staticClass: "input-group"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.inWt),
      expression: "inWt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0.25",
      "max": "200",
      "step": ".01",
      "placeholder": "Body weight in kg",
      "required": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.inWt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inWt = _vm._n($event.target.value)
      }
    }
  }), " ", _vm._m(7)]), " ", _vm._m(8)])]), " ", _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "panel-heading"
  }, [_vm._h('h4', ["Patient Data"])])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "col-md-1 col-md-offset-2"
  }, [_vm._h('label', ["Age:"])])
},function (){var _vm=this;
  return _vm._h('span', {
    staticClass: "input-group-addon"
  }, ["Y"])
},function (){var _vm=this;
  return _vm._h('span', {
    staticClass: "input-group-addon"
  }, ["M"])
},function (){var _vm=this;
  return _vm._h('span', {
    staticClass: "input-group-addon"
  }, ["D"])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "help-block with-errors"
  })
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "col-md-1 col-md-offset-2"
  }, [_vm._h('label', ["Weight:"])])
},function (){var _vm=this;
  return _vm._h('span', {
    staticClass: "input-group-addon"
  }, ["kg"])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "help-block with-errors"
  })
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "col-md-1"
  }, [_vm._h('input', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "reset"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-322ac99c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/DataInput.vue
// module id = 142
// module chunks = 0